import classNames from 'classnames/bind';
import styles from './ActivityPanel.module.css';
import PanelContainer from './PanelContainer';
import PanelHeader from './PanelHeader';
import {
  LAST_STUDY,
  NAME,
  SCHOOL_NAME,
  GRADE,
  GROUP,
  BOOK,
  TITLE,
  LAST_PAGE,
} from '../../../constants';

interface StudentLastStudy {
  userId: number;
  nm: string;
  schoolNm: string;
  gradeTypeNm: string;
  groupNames: string;
  title: string;
  page: string;
}

interface ClassLastStudyPanelProps {
  data: StudentLastStudy[];
  isOpen: boolean;
  onClose: () => void;
}

export default function ClassLastStudyPanel({
  data,
  isOpen,
  onClose,
}: ClassLastStudyPanelProps) {
  const cx = classNames.bind(styles);

  return (
    <PanelContainer isOpen={isOpen}>
      <PanelHeader
        cardId="last-learning"
        title={LAST_STUDY}
        isBeta
        onClose={onClose}
      />
      <div className={cx('widget_content', 'study', 'table')}>
        <div className={cx('table_container')}>
          <div
            className={cx('table_header', {
              dynamic_right_padding: data.length > 5,
            })}
          >
            <div>{NAME}</div>
            <div>{SCHOOL_NAME}</div>
            <div>{GRADE}</div>
            <div>{GROUP}</div>
            <div>
              {BOOK} {TITLE}
            </div>
            <div>{LAST_PAGE}</div>
          </div>
          <div className={cx('table_body')}>
            {data.map((student, i) => (
              <div key={i} className={cx('table_row')}>
                <div>{student.nm}</div>
                <div>{student.schoolNm}</div>
                <div>{student.gradeTypeNm}</div>
                <div>{student.groupNames}</div>
                <div>{student.title}</div>
                <div>{student.page}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </PanelContainer>
  );
}
